// @ts-nocheck
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router'
import isExternalUrl from 'helpers/isExternalUrl'

import { ChevronDownSmallIcon } from '@pleio/icons/chevron-down-small'
import { NewWindowSmallIcon } from '@pleio/icons/new-window-small'

import Link from './components/Link'

const MobileNavigationMenuItem = ({
    title,
    link,
    size,
    isOpen,
    toggleOpenSubmenu,
}) => {
    const { t } = useTranslation()

    // Has no child-items
    if (link) {
        if (isExternalUrl(link)) {
            return (
                <Link
                    as="a"
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    $size={size}
                    aria-label={`${title}${t('global.opens-in-new-window')}`}
                    role="menuitem"
                >
                    <span>{title}</span>
                    <NewWindowSmallIcon style={{ marginLeft: '8px' }} />
                </Link>
            )
        } else {
            return (
                <Link as={NavLink} to={link} $size={size} role="menuitem">
                    <span>{title}</span>
                </Link>
            )
        }
    } else {
        return (
            <Link
                as="button"
                $size={size}
                $isInverted={isOpen}
                onClick={toggleOpenSubmenu}
                aria-expanded={isOpen}
                role="menuitem"
            >
                <span>{title}</span>
                <ChevronDownSmallIcon className="ArrowDownIcon" />
            </Link>
        )
    }
}

export default memo(MobileNavigationMenuItem)
